import { render, staticRenderFns } from "./AmeliaRevStudent.vue?vue&type=template&id=1e0f5ccd"
import script from "./AmeliaRevStudent.vue?vue&type=script&lang=js"
export * from "./AmeliaRevStudent.vue?vue&type=script&lang=js"
import style0 from "./AmeliaRevStudent.vue?vue&type=style&index=0&id=1e0f5ccd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports